<template>
  <section v-if="contact" class="swap-contact" aria-label="Contacto de esta compra">
    <strong>{{ contact.role === 'seller' ? 'Tu vendedor' : 'Tu comprador' }}: {{ contact.name }}</strong>
    <span v-if="contact.email">{{ contact.email }}</span>
    <span v-if="contact.phone">{{ contact.phone }}</span>
    <div class="swap-contact__actions">
      <FomoButton variant="quiet" v-if="whatsappUrl" icon="fab fa-whatsapp" @click="open(whatsappUrl)">Contactar por WhatsApp</FomoButton>
      <FomoButton variant="quiet" v-if="contact.email_url" icon="fas fa-envelope" @click="open(contact.email_url)">Enviar correo</FomoButton>
    </div>
    <small>Contacto para coordinar esta entrega. Los mensajes de abajo quedan guardados en FOMO.</small>
  </section>
</template>
<script>
import FomoButton from '../ui/FomoButton.vue'
import { whatsappContactUrl } from '../../common/contactPhone'
export default {
  components: { FomoButton },
  props: { contact: { type: Object, default: null } },
  computed: { whatsappUrl() { return whatsappContactUrl(this.contact) } },
  methods: {
    open(url) { if (/^(https:\/\/wa\.me\/[1-9]\d{7,14}|mailto:[^\s]+)$/.test(url)) window.open(url, '_blank', 'noopener,noreferrer') },
  },
}
</script>
<style scoped>
.swap-contact{display:grid;gap:8px;min-width:0;font-family:var(--fomo-font-body);overflow-wrap:anywhere}
.swap-contact__actions{display:flex;flex-wrap:wrap;gap:12px}
.swap-contact small{line-height:1.5}
</style>
